import templatesWorker from "./templatesWorker.js";

export default class BaseClass {
    config = {};
    callbacks = {};
    utils = {};
    debounces = {};

    constructor(element) {
        this.element = null;
        this.$element = null;

        if (element != null) {
            this.element = element;
            this.element.jsObject = this;
            this.$element = $(this.element);

            this.elementID = null;
            let elementID = this.$element.attr("id");
            if (elementID != undefined) {
                this.elementID = elementID;
            }
            this.setInitDone();
        }

        this.currentLanguage = $('html').attr('lang');

        this.templatesWorker = new templatesWorker();

        this.csrfToken = $('meta[name="csrf-token"]').attr('content');
        this.isiOSDevice = navigator.platform.match(/iPhone|iPod|iPad/);
    }

    setInitDone() {
        this.$element.attr('data-state', 'init_done');
    }


    onReady(event) {
        if (event.target !== this.element) {
            return;
        }

        if (this.ready !== undefined) {
            this['ready'].call(this);
        }
    }

    ready() {
        // ...
    }

    onTeardown(event) {
        if (event.target !== this.element) {
            return;
        }

        if ((this.teardown !== undefined) && (this !== document)) {
            this['teardown'].call(this);
        }
    }

    teardown() {
        this.$element.off().remove();

        for (const utilName in this.utils) {
            if (this.utils[utilName].teardown !== undefined) {
                this.utils[utilName].teardown();
            }
        }
        delete this.utils;

        let $document = $(document);
        for (const eventName in this.debounces) {
            $document.off(eventName, this.debounces[eventName]);
        }
        delete this.debounces;

        for (const callback in this.callbacks) {
            if (this.callbacks[callback] !== undefined) {
                delete this[callback];
            }
        }
        delete this.callbacks;

        delete this.element;
        delete this.$element;
    }

    isVisible($viewPort, $element, minVisiblePercent = 100, previewPages = 0, viewPortcorrectionTop = 0, viewPortcorrentionBottom = 0) {

        if ($viewPort == undefined) {
            return;
        }

        let viewportHeight = 0;
        let viewportTop = 0;
        let viewportBottom = 0;
        let hiddenTop = 0;
        let hiddenBottom = 0;

        let elementHeight = 0;
        let elementTopOffset = 0;
        let elementBottom = 0;


        viewportHeight = $viewPort.innerHeight();
        elementHeight = $element.outerHeight();

        let onePercent = elementHeight / 100;

        if ($viewPort.parent().length == 0) {
            // Es wird gegen window getrackt

            viewportTop = $viewPort.scrollTop();
            viewportBottom = (viewportTop + viewportHeight);

            elementTopOffset = $element.offset().top;
            elementBottom = (elementTopOffset + elementHeight);

            viewportHeight = viewportHeight - viewPortcorrectionTop - viewPortcorrentionBottom;
            viewportTop = viewportTop + viewPortcorrectionTop;
            viewportBottom = viewportBottom - viewPortcorrentionBottom;

            if (previewPages > 0) {
                viewportHeight = viewportHeight + (viewportHeight * previewPages);
                viewportBottom = viewportBottom + (viewportHeight * previewPages);
            }

            hiddenTop = viewportTop - elementTopOffset;
            hiddenBottom = elementBottom - viewportBottom;

        } else {
            // Es wird gegen ein DOM-Element getrackt, hier muss die Berechnung geprüft werden

            if (previewPages > 0) {
                viewportHeight = viewportHeight + (viewportHeight * previewPages);
            }

            viewportBottom = viewportHeight; //
            elementTopOffset = $element.position().top;
            elementBottom = (elementTopOffset + elementHeight);

            hiddenTop = elementTopOffset * -1;
            hiddenBottom = elementBottom - viewportBottom;
        }

        if (hiddenTop < 0) {
            hiddenTop = 0;
        }
        if (hiddenBottom < 0) {
            hiddenBottom = 0;
        }

        let visiblePixel = elementHeight - hiddenTop - hiddenBottom;

        if (visiblePixel < 0) {
            visiblePixel = 0;
        }

        let visiblePercent = visiblePixel / onePercent;

        $element.attr('visiblePercent', visiblePercent);

        if (visiblePercent >= minVisiblePercent) {
            return true;
        }

        let maxPossiblePercent = viewportHeight / onePercent;

        $element.attr('maxPossiblePercent', maxPossiblePercent);

        if (maxPossiblePercent <= visiblePercent) {
            return true;
        }
        return false;
    }


    /**
     * @param $element
     * @param tolerance
     * @param deadzoneTop
     * @param deadzoneBottom
     * @returns {boolean}
     *
     * @deprecated, siehe isVisible()
     */
    isInViewport($element, tolerance = .2, deadzoneTop = 0, deadzoneBottom = 0) {

        const mySelf = this;

        let viewportHeight = $(window).height() - deadzoneTop - deadzoneBottom;
        let viewportTop = $(window).scrollTop() + deadzoneTop;
        let viewportBottom = (viewportTop + viewportHeight);

        let elementHeight = $element.innerHeight();
        let elementTopOffset = $element.offset().top;

        // todo prüfen
        if ($element.is(":hidden")) {
            $element.parents().each(function () {
                if (!$(this).is(":hidden")) {
                    elementTopOffset = $(this).offset().top;
                    return false;
                }
            });
        }

        let elementBottom = (elementTopOffset + elementHeight);

        let visibleSize = 0;


        let visible = (elementTopOffset + elementTopOffset * tolerance <= viewportBottom) && (elementBottom >= viewportTop);

        if (visible) {
            let hiddenTop = (viewportTop + deadzoneTop) - elementTopOffset;
            let hiddenBottom = elementBottom - viewportBottom;
            if (hiddenTop < 0) {
                hiddenTop = 0;
            }
            if (hiddenBottom < 0) {
                hiddenBottom = 0;
            }
            const onePercent = elementTopOffset / 100;
            visibleSize = (elementTopOffset - hiddenTop - hiddenBottom) / onePercent;
        }
        $element.attr("visiblesize", visibleSize);

        return visible;
    }

    generateRandomString(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
    }


    handleAjaxResponse(responseData) {

        let mySelf = this;

        if (responseData.actions != undefined) {

            responseData.actions.forEach(function (action) {
                switch (action.actionType) {
                    case "redirect":
                        mySelf.redirectUser(action.data.url);
                        break;

                    case "reloadpage":
                        mySelf.reloadPage(action.data.restorePosition);
                        break;

                    case "replace":
                        mySelf.replaceContent(action.data.content);
                        break;

                    case "setcontent":
                        mySelf.setContent(action.data.containerSelector, action.data.content);
                        break;

                    case "remove":
                        mySelf.removeContainer();
                        break;

                    case "removeall":
                        mySelf.removeAllContainers();
                        break;

                    case "closemodalelement":
                        mySelf.closemodalelement();
                        break;

                    case "closeallmodals":
                        mySelf.closeallmodals();
                        break;

                    case "reloadmodal":
                        mySelf.reloadmodal(action);
                        break;

                    case "openmodal":
                        mySelf.openModal(action.data.url);
                        break;

                    case "deleteconversationmessage":
                        mySelf.deleteConversationMessage(action.data);
                        break;

                    case "contentreload":
                        if (action.data.url != undefined) {
                            mySelf.triggerContentReload(action.data.containerID, action.data.url);
                        } else {
                            mySelf.triggerContentReload(action.data.containerID);
                        }
                        break;

                    case "closemodalcontentreload":
                        mySelf.closemodalelement();
                        if (action.data.url != undefined) {
                            mySelf.triggerContentReload(action.data.containerID, action.data.url);
                        } else {
                            mySelf.triggerContentReload(action.data.containerID);
                        }
                        break;

                    case "contentdelete":
                        mySelf.triggerDeleteElement(action?.data?.containerID);
                        break;

                    case "injectuploads":
                        mySelf.injectUploadsIntoDropZoneForm(action.data.source, action.data.uploads);
                        break;

                    case "notificationread":
                        mySelf.triggerNotificationRead();
                        break;

                    case "recalculatestate":
                        mySelf.triggerRecalculateState();
                        break;

                    case "nextstep":
                        mySelf.triggerNextStep();
                        break;

                    case "resetmediacentercheckboxcounter":
                        mySelf.resetMediaCenterCheckboxCounter();
                        break;

                    case "toastalert":
                        mySelf.triggerToastAlert(action.data.title, action.data.body, action.data.subtitle, action.data.type, action.data.placement, action.data.delay, action.data.autohide);
                        break;

                    case "refetchcalendarevents":
                        mySelf.refetchCalendarEvents();
                        break;

                    case "form_submit":
                        mySelf.triggerFormSubmit(action.data);
                        break;

                    case "triggerevent":
                        mySelf.triggerEvent(action.data);
                        break;
                }
            });
        }
    }

    triggerContentReload(containerID, url = null) {
        let eventData = {};
        eventData.id = containerID;

        if (url != null) {
            eventData.url = url;
        }
        $(document).trigger('content:reload', eventData);
    }

    deleteConversationMessage(data) {
        let triggerName = 'conversation:deleteMessage';

        if (data.type == 'chat') {
            triggerName = 'chat:deleteMessage';
        }
        $(document).trigger(triggerName, {msg: data.msg, conversationId: data.conversationId});
        $(document).trigger('modal:hide', {
            childelementID: this.$element.attr('id')
        });
    }

    reloadmodal(action) {

        let containerID = this.$element.attr('id');

        if (action.data != undefined && action.data.containerID != undefined) {
            containerID = action.data.containerID;
        }

        $(document).trigger('modal:reload', {
            childelementID: containerID
        });
    }

    openModal(contentUrl) {
        $(document).trigger('modal:open', {
            contentUrl: contentUrl
        });
    }

    closemodalelement() {
        $(document).trigger('modal:hide', {
            childelementID: this.$element.attr('id')
        });
    }

    closeallmodals() {
        $(document).trigger('modals:hide');
    }

    redirectUser(url) {
        window.location.href = url;
    }

    reloadPage(restorePosition) {
        if (restorePosition) {
            window.location.reload();
        } else {
            window.location.replace(window.location.href);
        }
    }

    replaceContent(content) {
        if (this.$replaceElement != null) {
            this.$replaceElement.html(content);
            $(document).trigger("content:loaded");
        } else {
            console.error('replace container not found');
        }
    }

    setContent(containerSelector, content) {
        let $container = $(containerSelector);
        $container.html(content);
        if (content.length > 0) {
            $container.removeClass('hidden');
        } else {
            $container.addClass('hidden');
        }
        $(document).trigger("content:loaded");
    }

    removeContainer() {
        if (this.$removeContainer != null) {
            this.$removeContainer.remove();
            $(document).trigger('container:removed');
        } else {
            console.error('remove container not found');
        }
    }

    removeAllContainers() {
        if (this.$removeContainer != null && this.$removeContainer[0].id) {
            $('.' + this.$removeContainer[0].id).remove();
            this.$removeContainer.remove();
            $(document).trigger('container:removed');
        } else {
            console.error('remove container not found');
        }
    }

    triggerDeleteElement(containerID) {
        if (containerID == undefined) {
            containerID = this.$element.data('delete-element-id');
        }

        $(document).trigger('content:delete', {
            elementId: containerID
        });
    }

    injectUploadsIntoDropZoneForm(source, uploads) {
        $(document).trigger('inject:uploads',
            {
                source: source,
                uploads: uploads,
            }
        );
    }

    triggerNotificationRead() {
        $(document).trigger('notification:read');
    }

    triggerRecalculateState() {
        $(document).trigger('state:recalculate');
    }

    triggerNextStep() {
        $(document).trigger('step:next');
    }

    getCurrentFullScreenElement() {
        if (document.fullscreenElement != null) {
            return document.fullscreenElement;
        } else if (document.mozFullScreenElement != null) {
            return document.mozFullScreenElement;
        } else if (document.webkitFullscreenElement != null) {
            return document.webkitFullscreenElement;
        } else if (document.msFullscreenElement != null) {
            return document.msFullscreenElement;
        }
        return null;
    }

    resetMediaCenterCheckboxCounter() {
        $(document).trigger('reset:mediaCenter:counter');
    }

    triggerToastAlert(title, body, subtitle, type, placement, delay, autohide) {
        $(document).trigger('toast:show', {title, body, subtitle, type, placement, delay, autohide});
    }

    refetchCalendarEvents() {
        $(document).trigger('refetch:calendar:events');
    }

    triggerFormSubmit(form) {
        const $body = $(document.body);
        const $form = $('<form />', {action: form.action, method: form.method});

        for (const name in form.data) {
            if (form.data.hasOwnProperty(name)) {
                const $input = $('<input />', {type: 'hidden', name: name, value: form.data[name]});

                $input.appendTo($form);
            }
        }

        $body.append($form);

        $form.trigger('submit');
    }

    triggerEvent(data) {
        $(document).trigger(data.event, data);
    }
}
